import { useNavigate } from "react-router-dom"
import Sidebar from "../components/Sidebar"
import { useEffect, useState } from "react"
import { APP_ROUTES } from "../utils/constants"
import {
    BotPackages,
    CompanyList,
    ManagerPanels,
    MusicPanels,
    Permissions,
    RadioList,
    ServerCommands,
    ServerPackages,
    SendGlobalMassage,
} from "../components/SettingsTabs/Tabs"
import BackupServer from "../components/SettingsTabs/BackupServer"
import { useAuth } from "../lib/useAuth"
import GenerateToken from "../components/SettingsTabs/GenerateToken"
import LogsTab from "../components/SettingsTabs/Logs/LogsTab"
import RankSystemSettings from "../components/SettingsTabs/RankSystemSettings"
import BannerDynamic from "../components/SettingsTabs/BannerDynamic"
import BannerPanels from "../components/SettingsTabs/BannerPanels"
import Jts3Settings from "../components/SettingsTabs/Jts3Settings"

const Settings = () => {
    const navigate = useNavigate()
    const { user, isAuthenticated } = useAuth()
    const [activeTab, setActiveTab] = useState("ServerCommands")
    if (!user || !isAuthenticated) {
        navigate(APP_ROUTES.SIGN_IN)
    }
    useEffect(() => {
        if (isAuthenticated) {
            var i, tabcontent, serverCommandsTab, defaultTab
            // Get all elements with class="tabcontent" and hide them
            tabcontent = document.getElementsByClassName("tabcontent")
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].className.replace(" openedTab", "")
            }
            defaultTab = document.getElementById("default-tab")
            defaultTab.className += " text-blue-500 border-b-2 font-medium border-b-blue-500 "

            serverCommandsTab = document.getElementById("ServerCommands")
            serverCommandsTab.className += " openedTab"
            setActiveTab("ServerCommands")
        }
        return () => {}
    }, [isAuthenticated])
    const openTab = (evt, tabName) => {
        // Declare all variables
        var i, tabcontent, tablinks
        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tabcontent")

        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = tabcontent[i].className.replace(" openedTab", "")
        }

        tablinks = document.getElementsByName("tablinks")

        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(
                " text-blue-500 border-b-2 font-medium border-b-blue-500",
                "",
            )
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(tabName).className += " openedTab"

        evt.target.className += " text-blue-500 border-b-2 font-medium border-b-blue-500 "
        setActiveTab(tabName)
    }
    return (
        <>
            <div className="settings">
                <div className="flex justify-end "></div>
                <div
                    class="tab grid bg-transparent text-sm text-white"
                    style={{ gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))" }}
                >
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "ServerPackages")}
                        >
                            سرور پکیج ها
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "BotPackages")}
                        >
                            بات پکیج ها
                        </button>
                    ) : null}

                    <button
                        id="default-tab"
                        name="tablinks"
                        className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                        onClick={(event) => openTab(event, "ServerCommands")}
                    >
                        دستور همگانی
                    </button>
                    <button
                        name="tablinks"
                        className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                        onClick={(event) => openTab(event, "SendGlobalMassage")}
                    >
                        ارسال پیام همگانی
                    </button>
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "RadioList")}
                        >
                            رادیو ها
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "CompanyList")}
                        >
                            کمپانی ها
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "Permissions")}
                        >
                            پرمیشن ها
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "ManagerPanels")}
                        >
                            پنل مدیریتی
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "BannerPanels")}
                        >
                            پنل بنر داینامیک
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "MusicPanels")}
                        >
                            پنل موزیک
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "BackupServer")}
                        >
                            بکاپ سرور
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "RanksystemSettings")}
                        >
                            تنظیمات رنک سیستم
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "BannerDynamic")}
                        >
                            تنظیمات بنر داینامیک
                        </button>
                    ) : null}
                    {user && user.scope === "admin" ? (
                        <button
                            name="tablinks"
                            className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                            onClick={(event) => openTab(event, "Jts3Settings")}
                        >
                            تنظیمات پنل Jts3
                        </button>
                    ) : null}
                    <button
                        name="tablinks"
                        className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                        onClick={(event) => openTab(event, "GenerateToken")}
                    >
                        ساخت توکن
                    </button>
                    <button
                        name="tablinks"
                        className="py-3 px-3 block hover:text-blue-500 focus:outline-none"
                        onClick={(event) => openTab(event, "LogsTab")}
                    >
                        لاگ ها
                    </button>
                </div>

                {user && user.scope === "admin" ? (
                    <>
                        <div id="BotPackages" class="tabcontent text-white mx-auto mt-5  flex flex-col w-full ">
                            {activeTab === "BotPackages" ? <BotPackages user={isAuthenticated} /> : null}
                        </div>
                    </>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="ServerPackages" class="tabcontent text-white mx-auto mt-5  flex flex-col w-full ">
                        {activeTab === "ServerPackages" ? <ServerPackages user={isAuthenticated} /> : null}
                    </div>
                ) : null}

                <div id="ServerCommands" class="tabcontent text-white mx-auto mt-5 w-full">
                    {activeTab === "ServerCommands" ? <ServerCommands user={isAuthenticated} /> : null}
                </div>

                <div id="SendGlobalMassage" class="tabcontent text-white mx-auto mt-5 w-full">
                    {activeTab === "SendGlobalMassage" ? <SendGlobalMassage user={isAuthenticated} /> : null}
                </div>
                {user && user.scope === "admin" ? (
                    <div id="RadioList" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "RadioList" ? <RadioList user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="CompanyList" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "CompanyList" ? <CompanyList user={isAuthenticated} /> : null}
                    </div>
                ) : null}

                {user && user.scope === "admin" ? (
                    <div id="Permissions" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "Permissions" ? <Permissions user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="BannerDynamic" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "BannerDynamic" ? <BannerDynamic user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="ManagerPanels" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "ManagerPanels" ? <ManagerPanels user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="BannerPanels" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "BannerPanels" ? <BannerPanels user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="MusicPanels" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "MusicPanels" ? <MusicPanels user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="BackupServer" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "BackupServer" ? <BackupServer user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="RanksystemSettings" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "RanksystemSettings" ? <RankSystemSettings user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                {user && user.scope === "admin" ? (
                    <div id="Jts3Settings" class="tabcontent text-white mx-auto mt-5 w-full">
                        {activeTab === "Jts3Settings" ? <Jts3Settings user={isAuthenticated} /> : null}
                    </div>
                ) : null}
                <div id="GenerateToken" class="tabcontent text-white mx-auto mt-5 w-full">
                    {activeTab === "GenerateToken" ? <GenerateToken user={isAuthenticated} /> : null}
                </div>
                <div id="LogsTab" class="tabcontent text-white mx-auto mt-5 w-full">
                    {activeTab === "LogsTab" ? <LogsTab activeTab={activeTab} /> : null}
                </div>
            </div>
        </>
    )
}

export default Settings
